import {useTheme} from 'contexts/ThemeContext';
import React from 'react';
import {Text, TouchableOpacity} from 'react-native';
import styleSheet from './styles';

export interface DayButtonProps {
  onPress(): void;
  selected: boolean;
  disabled: boolean;
  abbreviation: string;
  dayButtonStyle?: object;
}

const DayButton = (props: DayButtonProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  return (
    <TouchableOpacity
      disabled={props.disabled}
      style={[
        styles.defaultButtonStyle,
        styles.selectedButtonStyle(props.selected),
        props.dayButtonStyle,
      ]}
      activeOpacity={0.7}
      onPress={props.onPress}>
      <Text style={styles.textStyle(props.selected)}>{props.abbreviation}</Text>
    </TouchableOpacity>
  );
};

export default DayButton;
